import React from 'react';
import PropTypes from 'prop-types';

const ClosedCaptionsIcon = ({color = 'currentColor', ...props}) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect x="2" y="5" width="20" height="14" rx="2" />
    <path d="M7 11h3" />
    <path d="M7 14h2" />
    <path d="M14 11h3" />
    <path d="M14 14h2" />
  </svg>
);

ClosedCaptionsIcon.propTypes = {
  color: PropTypes.string,
};

export default ClosedCaptionsIcon;
